<script setup lang="ts">
import { cn } from '@/lib/utils'
import PBadge from 'primevue/badge'
import TieredMenu from 'primevue/tieredmenu'

const props = withDefaults(
  defineProps<{ items: DMenuItem[]; popup?: boolean; submenuClass?: string }>(),
  {
    popup: false,
    submenuClass: '',
  }
)

const menu = ref()
const toggle = (event: Event) => {
  menu.value.toggle(event)
}
</script>

<template>
  <!-- tailwind presetが入ったらDBtnにv-bind="props.action"を付与-->
  <slot name="trigger" :on="{ click: toggle }"></slot>
  <!-- 狭いときでもsubmenuをpopupさせたい時はbreakpointを指定。2段までとして横幅溢れない420pxを決め打ち-->
  <TieredMenu
    v-bind="$attrs"
    ref="menu"
    :model="items"
    :popup="popup"
    breakpoint="420px"
    class="px-0"
    :pt="{
      submenuLabel: { class: cn('py-1 !px-1 text-sm', submenuClass) },
      itemContent: { class: 'rounded-none !px-1' },
      submenu: { class: 'rounded-md px-0' },
    }"
  >
    <template #item="{ item, props, hasSubmenu }">
      <DBtn
        text
        plain
        size="small"
        :to="item.to"
        :target="item.target"
        :download="item.downloadName"
        class="!justify-start !w-full !rounded-none !ring-0 !px-1.5"
        @click="item.myCommand"
        :disabled="item.btnDisabled ? true : false"
      >
        <component
          :is="item.iconComponent"
          v-if="item.iconComponent"
          stroke-width="1.3"
          size="20"
          class="ml-[-2px] mr-[-3px] shrink-0"
        />
        <i v-if="item.pIconClass" :class="item.pIconClass"></i>
        <span class="whitespace-nowrap pl-2">{{ item.label }}</span>
        <PBadge v-if="item.badge" :value="item.badge" class="ml-auto" />
        <i v-if="hasSubmenu" class="pi pi-angle-right ml-auto"></i>
      </DBtn>
    </template>
  </TieredMenu>
</template>
